import React, { Component, useState, useEffect } from 'react'
import { useAuth, apiFetch } from "../hooks/useAuth";
import { sendEmailTemplate } from "../firebase";
// import {
//     DataGrid, GridRowsProp, GridColDef,
//     GridToolbarContainer, GridToolbarExport, GridActionsCellItem
// } from '@mui/x-data-grid';

import { DataGridPro, GridToolbar, GridToolbarContainer, GridToolbarExport, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';

import EmailIcon from '@mui/icons-material/Email';
import SquareIcon from '@mui/icons-material/Square';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ArticleIcon from '@mui/icons-material/Article';
import BookIcon from '@mui/icons-material/Book';

import {
    IconButton, FormControlLabel, Stack, Alert,
    LinearProgress, Box, Modal, Typography, Tooltip,
    Button, TextField
} from "@mui/material/";
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { ModalDownload, ModalContact } from "./Modal";
import { FormContactAbo } from "./FormFields";
import { deDE } from '@mui/x-data-grid-pro/locales'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    height: 600,
    p: 4,
};

export function AboListUmlauf() {
    const { user, change, claims, accountID } = useAuth();
}

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport
                printOptions={{
                    hideFooter: true,
                    hideToolbar: true,
                }}
            />
        </GridToolbarContainer>
    );
}

export function AboList() {
    const { user, change, claims, accountID, token } = useAuth();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('');
    const [message, setMessage] = useState("");
    const [data, setData] = useState([]);
    const [dataLieferhistorie, setDataLieferhistorie] = useState([]);
    const [filteredLieferhistorie, setFilteredLieferhistorie] = useState([]);
    const [showOnlyBelege, setShowOnlyBelege] = useState(false);
    const [open, setOpen] = useState(false);
    const [openLieferhistorie, setOpenLieferhistorie] = useState(false);
    
    // Debug token state
    // console.log("AboListSchoeningh - Token:", token);
    // console.log("AboListSchoeningh - User:", user);
    // console.log("AboListSchoeningh - AccountID:", accountID);

    const [currentRow, setCurrentRow] = useState(null);

    const [isModalDownloadOpen, setIsModalDownloadOpen] = useState(false);
    const [isModalContactOpen, setIsModalContactOpen] = useState(false);
    const [isModalUmlaufOpen, setIsModalUmlaufOpen] = useState(false);
    const [umlaufData, setUmlaufData] = useState([]);
    const [umlaufLoading, setUmlaufLoading] = useState(false);
    const [isCreatingUmlauf, setIsCreatingUmlauf] = useState(false);
    const [newUmlaufEntries, setNewUmlaufEntries] = useState([{ position: 1, name: '', bemerkung: '' }]);
    
    // Notification modal states
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationType, setNotificationType] = useState('error'); // 'error' or 'success'

    const apiRef = useGridApiRef();
    
    // Helper function to show notifications
    const showNotification = (message, type = 'error') => {
        setNotificationMessage(message);
        setNotificationType(type);
        setIsNotificationModalOpen(true);
    };
    
    const handleStatusClick = (status) => {
        apiRef.current.setFilterModel({
            items: [{ field: 'ArtikelTyp', operator: 'contains', value: status }],
        });
    };



    const handleCloseLieferhistorie = () => {
        setError("");
        setOpenLieferhistorie(false);
        setShowOnlyBelege(false);
    }
    
    const toggleBelegeFilter = () => {
        if (!showOnlyBelege) {
            // Filter to show only items with Belegart (documents)
            const filtered = dataLieferhistorie.filter(item => 
                item.Belegart && item.Belegart.trim() !== ''
            );
            setFilteredLieferhistorie(filtered);
        } else {
            // Show all items
            setFilteredLieferhistorie(dataLieferhistorie);
        }
        setShowOnlyBelege(!showOnlyBelege);
    }

    const handleOpenLieferhistorie = (row) => {
        setOpenLieferhistorie(true);

        var orderID = null;
        if (row.AuftragNr !== null && row.AuftragNr !== undefined) {
            orderID = String(row.AuftragNr);
            // Ensure we pass only the Artikelnummer expected by backend
            if (orderID.includes('-')) {
                orderID = orderID.split('-')[0];
            }
        }

        if (!orderID) {
            setError("Keine Auftragsnummer verfügbar");
            return;
        }

        console.log(orderID);
        let accountIDRow = row.KDNR;
     

        apiFetch("/app/abos/lieferungen/" + accountIDRow + "/" + orderID)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Die Daten konnten nicht geladen werden. ');
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                console.log(data);
                setDataLieferhistorie(data);
                setFilteredLieferhistorie(data);
                setShowOnlyBelege(false);

                if (data.message)
                    setMessage(data.message);
            })
            .catch((err) => {
                setLoading(false);
                setError(err.message);
            });

    }

    const handleOpenUmlauf = async (row) => {
        setIsModalUmlaufOpen(true);
        setUmlaufLoading(true);
        setUmlaufData([]);
        
        try {
            const accountIDRow = row.KDNR;
            const artikelnummer = row.AuftragNr;
            
            if (!artikelnummer) {
                setUmlaufData([]);
                setUmlaufLoading(false);
                return;
            }
            
            const response = await apiFetch(`/app/abos/umlauf/${accountIDRow}/${artikelnummer}`);
            
            if (!response.ok) {
                throw new Error('Umlaufzettel konnten nicht geladen werden');
            }
            
            const data = await response.json();
            setUmlaufData(data);
        } catch (err) {
            console.error('Error loading umlauf:', err);
            setUmlaufData([]);
        } finally {
            setUmlaufLoading(false);
        }
    };

    const handleCloseUmlauf = () => {
        setIsModalUmlaufOpen(false);
        setUmlaufData([]);
        setIsCreatingUmlauf(false);
        setNewUmlaufEntries([{ position: 1, name: '', bemerkung: '' }]);
    };

    const handleAddUmlaufEntry = () => {
        const nextPosition = newUmlaufEntries.length + 1;
        setNewUmlaufEntries([...newUmlaufEntries, { position: nextPosition, name: '', bemerkung: '' }]);
    };

    const handleRemoveUmlaufEntry = (index) => {
        const updated = newUmlaufEntries.filter((_, i) => i !== index);
        // Renumber positions
        const renumbered = updated.map((entry, i) => ({ ...entry, position: i + 1 }));
        setNewUmlaufEntries(renumbered);
    };

    const handleUmlaufEntryChange = (index, field, value) => {
        const updated = [...newUmlaufEntries];
        updated[index][field] = value;
        setNewUmlaufEntries(updated);
    };

    const handleEditUmlauf = () => {
        // Populate form with existing data
        if (umlaufData && umlaufData.length > 0) {
            const existingEntries = umlaufData.map((entry, index) => ({
                position: index + 1,
                name: entry.name || '',
                bemerkung: entry.bemerkung || ''
            }));
            setNewUmlaufEntries(existingEntries);
        } else {
            setNewUmlaufEntries([{ position: 1, name: '', bemerkung: '' }]);
        }
        setIsCreatingUmlauf(true);
    };

    const handleSubmitUmlauf = async () => {
        if (!currentRow) return;
        
        try {
            setUmlaufLoading(true);
            
            const accountIDRow = currentRow.KDNR;
            const artikelnummer = currentRow.AuftragNr;
            
            // Prepare email data for template
            const emailData = {
                template: 'umlaufzettel',
                user: {
                    email: claims?.email || 'Nicht verfügbar',
                    name: claims?.name || 'Nicht verfügbar',
                    uid: claims?.uid || 'Nicht verfügbar'
                },
                form: {
                    kundennummer: accountIDRow,
                    kundenname: currentRow.Kundenname || 'Unbekannt',
                    artikelnummer: artikelnummer,
                    titel: currentRow.Titel || 'Nicht verfügbar',
                    entries: newUmlaufEntries,
                    createdAt: new Date().toLocaleString('de-DE')
                },
                currentYear: new Date().getFullYear()
            };
            
            // Send email using the existing firebase function
            await sendEmailTemplate(emailData);
            
            showNotification('Umlaufzettel wurde erfolgreich an den Administrator gesendet', 'success');
            handleCloseUmlauf();
            
        } catch (err) {
            console.error('Error submitting umlauf:', err);
            showNotification('Fehler beim Senden des Umlaufzettels: ' + err.message, 'error');
        } finally {
            setUmlaufLoading(false);
        }
    };


    const currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

    useEffect(() => {
        setData("");
        setError(""); // Clear any previous errors

        if (!accountID) {
            setError("Es wurde keine AccountID ausgewaehlt");
            return;
        }

        // Wait for token to be available before making API call
        if (!token) {
            console.log("Token not available yet, waiting...");
            return; // Don't make the API call yet
        }

        setLoading(true);

        // Handle accountID as array - send all selected accounts
        const accountIdString = Array.isArray(accountID) ? accountID.join(',') : accountID;
        console.log("Making API call to:", "/app/abos/" + accountIdString);

        apiFetch("/app/abos/" + accountIdString)
            .then((res) => {
                console.log("API Response status:", res.status);
                console.log("API Response headers:", res.headers);
                if (!res.ok) {
                    return res.text().then(text => {
                        console.log("API Error response text:", text);
                        throw new Error(text || `HTTP ${res.status}`);
                    });
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                console.log("API Success data:", data);
                // Ensure data is always an array
                if (Array.isArray(data)) {
                    setData(data);
                } else if (data && Array.isArray(data.data)) {
                    setData(data.data);
                } else {
                    setData([]);
                    setError('Unerwartetes Datenformat erhalten');
                }
                if (data.message)
                    setMessage(data.message);
            })
            .catch((err) => {
                setLoading(false);
                console.log("API Error:", err.message); // Debug log
                
                // Filter out token-related errors for Schoeningh
                if (err.message.includes("definierten User Token") || err.message.includes("User Token")) {
                    console.log("Filtering out token error for Schoeningh");
                    return; // Don't set the error
                }
                
                setError(err.message);
            });
    }, [accountID, token]);

    return (

        <div style={{ height: "670px", width: '100%' }}>
            <Box
                mt={2}
                mb={2}
                sx={{ width: '100%', height: 4 }}>
                {loading && <LinearProgress />}

            </Box>

            {error && <Alert severity="error">{error}</Alert>}
            {message && <Alert severity="info">{message}</Alert>}


            <Modal
                open={openLieferhistorie}
                onClose={handleCloseLieferhistorie}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ textAlign: 'center', flex: 1 }}
                        >
                            Lieferhistorie{currentRow?.Titel ? ` - ${currentRow.Titel}` : ''}
                        </Typography>
                        <IconButton 
                            onClick={handleCloseLieferhistorie}
                            sx={{ 
                                position: 'absolute', 
                                top: 16, 
                                right: 16,
                                color: 'text.secondary'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    
                    <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Button
                            variant={showOnlyBelege ? "contained" : "outlined"}
                            color="primary"
                            size="small"
                            onClick={toggleBelegeFilter}
                        >
                            {showOnlyBelege ? 'Alle anzeigen' : 'Nur Belege anzeigen'}
                        </Button>
                        <Typography variant="body2" color="text.secondary">
                            {filteredLieferhistorie.length} von {dataLieferhistorie.length} Einträgen
                        </Typography>
                    </Box>

                    <DataGridPro
                        pageSize={100}
                        rowsPerPageOptions={[50, 100, 200, 500]}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        sx={{
                            height: '400px',
                            overflow: 'auto',
                            '& .MuiDataGrid-cell': {
                                fontSize: '0.8rem'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                fontSize: '0.8rem'
                            }
                        }}
                        components={{
                            Toolbar: CustomToolbar,
                        }}

                        initialState={{ 
                            pinnedColumns: { right: ['actions2'] },
                            pagination: { paginationModel: { pageSize: 100 } }
                        }}
                        rows={filteredLieferhistorie}
                        columns={[
                            {
                                field: 'Datum',
                                headerName: "Datum",
                                type: "date",
                                width: 100,
                                valueFormatter: (params) => dayjs(params).format('DD.MM.YYYY'),
                            },
                            {
                                field: 'Titel',
                                headerName: "Titel",
                                width: 200,
                      
                            },
                            {
                                field: 'AuftragNr',
                                headerName: "Artikel-Nr.",
                                width: 80,
                            },
                            {
                                field: 'AuftragPosLfdnr',
                                headerName: "Folge-Nr.",
                                width: 70,
                            },
                          
                            {
                                field: 'Anzahl',
                                headerName: "Anzahl",
                                type: "number",
                                width: 50,
                            },
                            {
                                field: 'Preis',
                                headerName: "Einzelpreis",
                                type: "number",
                                width: 80,
                                valueFormatter: (params) => currencyFormatter.format(params),
                            },
                            // {
                            //     field: 'Gesamtpreis',
                            //     headerName: "Gesamtpreis",
                            //     type: "number",
                            //     width: 120,
                            //     valueFormatter: (params) => currencyFormatter.format(params),
                            // },
                            {
                                field: 'Belegart',
                                headerName: "Belegart",
                                width: 100,
                            },
                            // // {
                            // //     field: 'Status',
                            // //     headerName: "Status",
                            // //     width: 80,
                            // },
                            {
                                field: 'Belegnummer',
                                headerName: "Belegnummer",
                                width: 110,
                            },
                            // {
                            //     field: 'Rechnungskunde',
                            //     headerName: "Rechnungskunde",
                            //     width: 130,
                            // },
                     
                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Aktionen',
                                width: 80,
                                getActions: (params) => {
                                    const actions = [];
                                    
                                    // Only show download icon if Belegnummer is not 0
                                    if (params.row.Belegnummer && params.row.Belegnummer !== 0) {
                                        actions.push(
                                            <Tooltip title="Belege herunterladen">
                                                <GridActionsCellItem
                                                    onClick={async () => {
                                                        // Construct PDF name from Belegart and Belegnummer
                                                        let pdfName = '';
                                                        
                                                        if (params.row.Belegart === 'Rechnung') {
                                                            pdfName = 'RG_' + params.row.Belegnummer;
                                                        } else if (params.row.Belegart === 'Lieferschein') {
                                                            pdfName = 'LS_' + params.row.Belegnummer;
                                                        } else if (params.row.Belegart === 'Gutschrift') {
                                                            pdfName = 'GS_' + params.row.Belegnummer;
                                                        } else {
                                                            // Fallback: use Belegart + Belegnummer
                                                            pdfName = params.row.Belegart + params.row.Belegnummer;
                                                        }
                                                        
                                                        let accountIDRow = params.row.Rechnungskunde;
                                                    
                                                        // Trigger direct download
                                                        try {
                                                            const response = await apiFetch("/app/download/" + accountIDRow + "/" + pdfName, {
                                                                headers: {
                                                                    "Authorization": "Bearer " + token,
                                                                },
                                                            });
                                                            
                                                            if (!response.ok) {
                                                                // Extract error message from response
                                                                let errorMessage = 'Download failed';
                                                                try {
                                                                    const errorText = await response.text();
                                                                    errorMessage = errorText || response.statusText || errorMessage;
                                                                } catch (e) {
                                                                    errorMessage = response.statusText || errorMessage;
                                                                }
                                                                throw new Error(errorMessage);
                                                            }
                                                            
                                                            const blob = await response.blob();
                                                            const url = URL.createObjectURL(blob);
                                                            const a = document.createElement('a');
                                                            a.href = url;
                                                            
                                                            // Get filename from Content-Disposition header or use default
                                                            const contentDisposition = response.headers.get('Content-Disposition');
                                                            const fileName = contentDisposition
                                                                ? contentDisposition.split('filename=')[1]?.replace(/"/g, '')
                                                                : pdfName + '.pdf';
                                                            
                                                            a.download = fileName;
                                                            a.click();
                                                            window.URL.revokeObjectURL(url);
                                                            
                                                            // Show success notification
                                                            showNotification(`Dokument ${fileName} wurde erfolgreich heruntergeladen`, 'success');
                                                            
                                                        } catch (error) {
                                                            console.error('Download error:', error);
                                                            showNotification( error.message, 'error');
                                                        }
                                                    }}
                                                    icon={<CloudDownloadIcon />} label="Download" />
                                            </Tooltip>
                                        );
                                    }
                                    
                                    return actions;
                                },
                            },


                        ]}
                    />
                </Box>
            </Modal>


            <ModalDownload row={currentRow} isModalOpen={isModalDownloadOpen} handleCloseModal={() => setIsModalDownloadOpen(false)} />
            
            {/* Custom Modal for Abo Messages */}
            <Modal
                open={isModalContactOpen}
                onClose={() => setIsModalContactOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Nachricht
                        </Typography>
                        <IconButton 
                            onClick={() => setIsModalContactOpen(false)}
                            sx={{ 
                                position: 'absolute', 
                                top: 16, 
                                right: 16,
                                color: 'text.secondary'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Nachricht für Artikel {currentRow?.AuftragNr} - {currentRow?.Titel}
                    </Typography>
                    <FormContactAbo currentRow={currentRow} handleClose={() => setIsModalContactOpen(false)} template="aboMessage" />
                </Box>
            </Modal>
            
            {/* Notification Modal */}
            <Modal
                open={isNotificationModalOpen}
                onClose={() => setIsNotificationModalOpen(false)}
                aria-labelledby="notification-modal-title"
                aria-describedby="notification-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography id="notification-modal-title" variant="h6" component="h2">
                            {notificationType === 'error' ? '❌ Fehler' : '✅ Erfolg'}
                        </Typography>
                        <IconButton 
                            onClick={() => setIsNotificationModalOpen(false)}
                            sx={{ 
                                color: 'text.secondary',
                                '&:hover': {
                                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography id="notification-modal-description" sx={{ mb: 3 }}>
                        {notificationMessage}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton
                            onClick={() => setIsNotificationModalOpen(false)}
                            sx={{
                                bgcolor: notificationType === 'error' ? '#f44336' : '#4caf50',
                                color: 'white',
                                '&:hover': {
                                    bgcolor: notificationType === 'error' ? '#d32f2f' : '#388e3c',
                                },
                                px: 3,
                                py: 1,
                                borderRadius: 1,
                            }}
                        >
                            <Typography variant="button">OK</Typography>
                        </IconButton>
                    </Box>
                </Box>
            </Modal>

            {/* Umlaufzettel Modal */}
            <Modal
                open={isModalUmlaufOpen}
                onClose={handleCloseUmlauf}
                aria-labelledby="umlauf-modal-title"
                aria-describedby="umlauf-modal-description"
            >
                <Box sx={{...style, overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box>
                            <Typography id="umlauf-modal-title" variant="h6" component="h2">
                                📋 Umlaufzettel
                            </Typography>
                    
                        </Box>
                        <IconButton 
                            onClick={handleCloseUmlauf}
                            sx={{ 
                                position: 'absolute', 
                                top: 16, 
                                right: 16,
                                color: 'text.secondary'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    
                    <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                        {currentRow && (
                            <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                                    <strong>Artikel:</strong> {currentRow.AuftragNr} - {currentRow.Titel}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                                    <strong>Kunde:</strong> {currentRow.KDNR}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    <strong>Typ:</strong> {currentRow.ArtikelTyp}
                                </Typography>
                            </Box>
                        )}
                        
                        {umlaufLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                            <LinearProgress sx={{ width: '50%' }} />
                        </Box>
                    ) : umlaufData.length === 0 && !isCreatingUmlauf ? (
                        <Box>
                            <Alert severity="info" sx={{ mb: 2 }}>
                                Keine Umlaufzettel-Daten verfügbar
                            </Alert>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick={() => setIsCreatingUmlauf(true)}
                                startIcon={<AddCircleOutlineIcon />}
                            >
                                Neuen Umlaufzettel erstellen
                            </Button>
                        </Box>
                    ) : isCreatingUmlauf ? (
                        <Box sx={{ height: 400, overflow: 'auto' }}>
                            <Box sx={{ mb: 2, p: 2, bgcolor: 'info.50', borderRadius: 1, border: '1px solid', borderColor: 'info.200' }}>
                                <Typography variant="body2" sx={{ color: 'info.800', mb: 1 }}>
                                    <strong>📋 Umlaufzettel erstellen</strong>
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    Fügen Sie Personen hinzu, die den Umlaufzettel erhalten sollen. Die Daten werden per E-Mail an den Administrator gesendet.
                                </Typography>
                            </Box>
                            
                            <Stack spacing={2}>
                                {newUmlaufEntries.map((entry, index) => (
                                    <Box key={index} sx={{ 
                                        p: 2, 
                                        border: '1px solid #e0e0e0', 
                                        borderRadius: 2,
                                        bgcolor: '#fafafa',
                                        '&:hover': {
                                            bgcolor: '#f5f5f5',
                                            borderColor: '#d0d0d0'
                                        }
                                    }}>
                                        <Stack direction="row" spacing={2} alignItems="flex-start">
                                            <Box sx={{ 
                                                minWidth: 80, 
                                                p: 1, 
                                                bgcolor: 'primary.100', 
                                                borderRadius: 1,
                                                textAlign: 'center'
                                            }}>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.800' }}>
                                                    #{entry.position}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <TextField
                                                    label="Name *"
                                                    value={entry.name}
                                                    onChange={(e) => handleUmlaufEntryChange(index, 'name', e.target.value)}
                                                    size="small"
                                                    fullWidth
                                                    required
                                                    error={!entry.name.trim()}
                                                    helperText={!entry.name.trim() ? 'Name ist erforderlich' : ''}
                                                    sx={{ mb: 1 }}
                                                />
                                                <TextField
                                                    label="Bemerkung (optional)"
                                                    value={entry.bemerkung}
                                                    onChange={(e) => handleUmlaufEntryChange(index, 'bemerkung', e.target.value)}
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    placeholder="Zusätzliche Informationen..."
                                                />
                                            </Box>
                                            <IconButton 
                                                onClick={() => handleRemoveUmlaufEntry(index)}
                                                disabled={newUmlaufEntries.length === 1}
                                                color="error"
                                                size="small"
                                                sx={{ 
                                                    mt: 1,
                                                    '&:hover': {
                                                        bgcolor: 'error.50'
                                                    }
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Stack>
                                    </Box>
                                ))}
                            </Stack>
                            
                            <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                                <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={handleAddUmlaufEntry}
                                        startIcon={<AddCircleOutlineIcon />}
                                        color="primary"
                                        sx={{ minWidth: 160 }}
                                    >
                                        Position hinzufügen
                                    </Button>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {newUmlaufEntries.length} Position{newUmlaufEntries.length !== 1 ? 'en' : ''} hinzugefügt
                                    </Typography>
                                </Stack>
                                
                                <Stack direction="row" spacing={2} justifyContent="flex-end">
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => {
                                            setIsCreatingUmlauf(false);
                                            setNewUmlaufEntries([{ position: 1, name: '', bemerkung: '' }]);
                                        }}
                                        disabled={umlaufLoading}
                                    >
                                        Abbrechen
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        onClick={handleSubmitUmlauf}
                                        disabled={umlaufLoading || newUmlaufEntries.some(entry => !entry.name.trim())}
                                        startIcon={umlaufLoading ? <LinearProgress size={16} /> : <EmailIcon />}
                                        color="primary"
                                        sx={{ minWidth: 200 }}
                                    >
                                        {umlaufLoading ? 'Sende...' : 'An Administrator senden'}
                                    </Button>
                                </Stack>
                                
                                {newUmlaufEntries.some(entry => !entry.name.trim()) && (
                                    <Alert severity="warning" sx={{ mt: 2 }}>
                                        Bitte füllen Sie alle Namen aus, bevor Sie den Umlaufzettel senden.
                                    </Alert>
                                )}
                            </Box>
                        </Box>
                    ) : (
                        <Box>
                            <Box sx={{ mb: 2, p: 2, bgcolor: 'primary.50', borderRadius: 1 }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Box>
                                        <Typography variant="h6" sx={{ mb: 1, color: 'primary.main' }}>
                                            📋 Umlaufzettel Übersicht
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                            {umlaufData.length} Einträge gefunden
                                        </Typography>
                                    </Box>
                                    <Button 
                                        variant="outlined" 
                                        size="small"
                                        onClick={handleEditUmlauf}
                                        startIcon={<AddCircleOutlineIcon />}
                                        color="primary"
                                    >
                                        Bearbeiten
                                    </Button>
                                </Stack>
                            </Box>
                            <Box sx={{ height: 400, overflow: 'auto' }}>
                                <DataGridPro
                                rows={umlaufData}
                                columns={[
                                    {
                                        field: 'position',
                                        headerName: 'Position',
                                        width: 80,
                                        align: 'center',
                                        headerAlign: 'center',
                                    },
                                    {
                                        field: 'name',
                                        headerName: 'Name',
                                        width: 250,
                                        flex: 1,
                                        renderCell: (params) => (
                                            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                                {params.value}
                                            </Typography>
                                        ),
                                    },
                                    {
                                        field: 'bemerkung',
                                        headerName: 'Bemerkung',
                                        width: 250,
                                        flex: 1,
                                        renderCell: (params) => (
                                            <Typography variant="body2" sx={{ fontStyle: params.value ? 'normal' : 'italic', color: params.value ? 'text.primary' : 'text.secondary' }}>
                                                {params.value || 'Keine Bemerkung'}
                                            </Typography>
                                        ),
                                    },
                                ]}
                                pageSize={10}
                                rowsPerPageOptions={[10, 25, 50]}
                                disableSelectionOnClick
                                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        borderBottom: '1px solid #e0e0e0',
                                        display: 'flex',
                                        alignItems: 'center',
                                    },
                                    '& .MuiDataGrid-row:hover': {
                                        bgcolor: 'action.hover',
                                    },
                                }}
                            />
                            </Box>
                        </Box>
                    )}
                    </Box>
                </Box>
            </Modal>

            <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <Box 
                    onClick={() => handleStatusClick("Zeitschrift")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <ArticleIcon style={{ color: '#2e7d32' }} />
                    <Typography color="text.secondary">Zeitschrift</Typography>
                </Box>

                <Box 
                    onClick={() => handleStatusClick("Fortsetzung")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <BookIcon style={{ color: '#1976d2' }} />
                    <Typography color="text.secondary">Fortsetzung</Typography>
                </Box>

                <Box 
                    onClick={() => handleStatusClick("Online-Datenbank")} 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 0.5, 
                        cursor: 'pointer',
                        p: 1,
                        borderRadius: 1,
                        '&:hover': { bgcolor: 'action.hover' }
                    }}
                >
                    <CloudDownloadIcon style={{ color: '#ff9800' }} />
                    <Typography color="text.secondary">Online-Datenbanken</Typography>
                </Box>
            </Stack>

            <div style={{ display: 'flex', height: '100%', width: '100%' }}>
                <div style={{ flexGrow: 1, width: '100%', overflow: 'hidden' }}>
                    <DataGridPro
                        apiRef={apiRef}
                        pageSize={10}
                        autoSizeColumns={true}
                        sx={{ 
                            width: '100%',
                            '& .MuiDataGrid-cell': {
                                fontSize: '0.8rem'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                fontSize: '0.8rem'
                            }
                        }}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        components={{
                            Toolbar: GridToolbar
                        }}
                        getRowId={(row, index) => {
                            // Create a unique ID using available fields, fallback to index
                            try {
                                const auftragNr = row.AuftragNr || 'unknown';
                                const posLfdnr = row.AuftragPosLfdnr || 0;
                                const kdnr = row.KDNR || 'unknown';
                                
                                // If we have valid data, use it
                                if (auftragNr !== 'unknown' && kdnr !== 'unknown') {
                                    return `${auftragNr}-${posLfdnr}-${kdnr}`;
                                }
                                
                                // Fallback to index-based ID
                                return `row-${index}`;
                            } catch (error) {
                                console.error('Error generating row ID:', error, { row, index });
                                return `row-${index}`;
                            }
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            },
                            filterPanel: {
                                onKeyDown: (event) => {
                                    console.log(event.key);
                                    if (event.key === 'Enter') {
                                        apiRef.current.hideFilterPanel()
                                    }
                                }
                            }
                        }}

                        initialState={{ pinnedColumns: { right: ['actions2'] } }}
                        rows={Array.isArray(data) ? data.filter(row => {
                            if (!row || typeof row !== 'object') {
                                console.warn('Invalid row data:', row);
                                return false;
                            }
                            return true;
                        }) : []}
                        columns={[
                            {
                                field: 'ArtikelTyp',
                                headerName: "Typ",
                                width: 40,
                                renderCell: (params) => {
                                    const value = params.value;
                                    let icon;
                                    if (value === 'Zeitschrift') {
                                        icon = <ArticleIcon style={{ color: '#2e7d32' }} />; // Green for Zeitschriften
                                    } else if (value === 'Fortsetzung') {
                                        icon = <BookIcon style={{ color: '#1976d2' }} />; // Blue for Fortsetzungen
                                    } else if (value === 'Online-Datenbank') {
                                        icon = <CloudDownloadIcon style={{ color: '#ff9800' }} />; // Orange for Online-Datenbanken
                                    } else {
                                        return value;
                                    }
                                    
                                    return (
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            {icon}
                                        </Box>
                                    );
                                },
                            },
                        
                            {
                                field: 'Titel',
                                width: 200,
                                renderCell: (params) => {
                                    if (!params.value) return '';
                                    
                                    return (
                                        <div style={{
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            lineHeight: '1.2',
                                            padding: '4px 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '100%',
                                            fontSize: '0.8rem'
                                        }}>
                                            {params.value}
                                        </div>
                                    );
                                }
                            },

                            {
                                field: 'Anzahl',
                                width: 50
                            },
                       
                            {
                                field: 'Liefertext',
                                headerName: "Liefertext",
                                width: 180,
                                renderCell: (params) => {
                                    if (!params.value) return '';
                                    const text = params.value;
                                    return (
                                        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>} placement="top-start">
                                            <div style={{
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word',
                                                lineHeight: '1.2',
                                                padding: '4px 0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '100%',
                                                maxHeight: '60px',
                                                overflow: 'hidden',
                                                fontSize: '0.8rem'
                                            }}>
                                                {text}
                                            </div>
                                        </Tooltip>
                                    );
                                }
                            },
                            {
                                field: 'Lieferant',
                                headerName: "Verlag",
                                width: 150
                            },
                            {
                                field: 'AuftragNr',
                                headerName: "ArtikelNr.",
                                width: 80
                            },
                            {
                                field: 'KDNR',
                                headerName: "KundenNr.",
                                width: 70
                            },
                            {
                                field: 'BezugSeit',
                                headerName: "Bezug seit",
                                type: "date",
                                width: 90,
                                valueGetter: (value) => {
                                    if (!value) return null;
                                    // Parse German date format (DD.MM.YYYY) from database
                                    const parts = value.split('.');
                                    if (parts.length !== 3) return null;
                                    // Create date as YYYY-MM-DD for proper sorting
                                    const date = new Date(parts[2], parts[1] - 1, parts[0]);
                                    return isNaN(date.getTime()) ? null : date;
                                },
                                valueFormatter: (value) => {
                                    if (!value) return '';
                                    // Value is already a Date object from valueGetter
                                    return dayjs(value).format('DD.MM.YYYY');
                                }
                            },
                            {
                                field: 'BerechnetBis',
                                headerName: "Berechnet bis",
                                type: "date",
                                width: 90,
                                valueGetter: (value) => {
                                    if (!value) return null;
                                    // Parse German date format (DD.MM.YYYY) from database
                                    const parts = value.split('.');
                                    if (parts.length !== 3) return null;
                                    // Create date as YYYY-MM-DD for proper sorting
                                    const date = new Date(parts[2], parts[1] - 1, parts[0]);
                                    return isNaN(date.getTime()) ? null : date;
                                },
                                valueFormatter: (value) => {
                                    if (!value) return '';
                                    // Value is already a Date object from valueGetter
                                    return dayjs(value).format('DD.MM.YYYY');
                                }
                            },
                            {
                                field: 'BezugBis',
                                headerName: "Bezug bis",
                                type: "date",
                                width: 90,
                                valueGetter: (value) => {
                                    if (!value) return null;
                                    // Parse MM.YYYY format from bezugbis field
                                    const parts = value.split('.');
                                    if (parts.length !== 2) return null;
                                    // Create date as YYYY-MM-DD for proper sorting (first day of month)
                                    const date = new Date(parts[1], parts[0] - 1, 1);
                                    return isNaN(date.getTime()) ? null : date;
                                },
                                valueFormatter: (value) => {
                                    if (!value) return '';
                                    // Value is already a Date object from valueGetter
                                    return dayjs(value).format('MM.YYYY');
                                }
                            },
                            {
                                field: 'ZusaetzlicherRechnungstext',
                                headerName: "Zusätzl. Rechnungstext",
                                width: 500,
                                renderCell: (params) => {
                                    if (!params.value) return '';
                                    const text = params.value;
                                    return (
                                        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>} placement="top-start">
                                            <div style={{
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word',
                                                lineHeight: '1.2',
                                                padding: '4px 0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '100%',
                                                maxHeight: '60px',
                                                overflow: 'hidden',
                                                fontSize: '0.8rem'
                                            }}>
                                                {text}
                                            </div>
                                        </Tooltip>
                                    );
                                }
                            },
                            {
                                field: 'actions2',
                                type: 'actions',
                                headerName: 'Aktionen',
                                width: 160,
                                getActions: (params) => {
                                    const actions = [
                                        <Tooltip title="Nachricht">
                                            <GridActionsCellItem
                                                onClick={() => {
                                                    // handleOpen(params.row);
                                                    setCurrentRow(params.row);
                                                    setIsModalContactOpen(true);

                                                }}
                                                icon={<EmailIcon />} label="Nachricht" />

                                        </Tooltip>,

                                        <Tooltip title="Lieferhistorie anzeigen">
                                            <GridActionsCellItem
                                                onClick={() => {
                                                    // handleOpenDownload(params.row);
                                                    setCurrentRow(params.row);
                                                    handleOpenLieferhistorie(params.row);
                                                }}
                                                icon={<DeliveryDiningIcon />} label="Lieferung" />

                                        </Tooltip>
                                    ];

                                    // Add Umlaufzettel for Zeitschriften and Fortsetzungen
                                    if (params.row.ArtikelTyp === 'Zeitschrift' || params.row.ArtikelTyp === 'Fortsetzung') {
                                        actions.push(
                                            <Tooltip title="Umlaufzettel anzeigen">
                                                <GridActionsCellItem
                                                    onClick={() => {
                                                        setCurrentRow(params.row);
                                                        handleOpenUmlauf(params.row);
                                                    }}
                                                    icon={<ArticleIcon />} label="Umlauf" />
                                            </Tooltip>
                                        );
                                    }

                                    return actions;
                                },
                            }
                        ]}
                    />
                </div>
            </div>

        </div >
    )
}

// Export AboList as AboListSchoeningh for compatibility
export { AboList as AboListSchoeningh };

